import { Activite } from './activite.model';

export interface Indisponibilite extends Activite {
  typeIndispo: TypeIndisponibilite;
  libelle: string;
  statut: StatutIndisponibilite;
  adresse: string;
  codePostal: string;
  ville: string;
  complementAdresse: string;
  commentaire: string;
  coordonneesX: string;
  coordonneesY: string;
}

export enum TypeIndisponibilite {
  Travaillee = 'travaillee',
  NonTravaillee = 'non_travaillee',
}

export enum StatutIndisponibilite {
  Demandee = 'demandee',
  Acceptee = 'acceptee',
}

export enum MotifIndisponibilite {
  Vehicule = 'vehicule',
  Maladie = 'maladie',
  Deplacement = 'deplacement',
  Accident = 'accident',
  Repos = 'repos',
  Autre = 'autre',
}

export interface IndisponibilitePosition {
  isLeft: boolean;
  isRight: boolean;
  isAll: boolean;
}
